export var tooltipConfig = function tooltipConfig(theme) {
  return {
    // Hacky way in conjunction with footerFontSize to get Chart.js to respect
    // consistent padding at the bottom of tooltips
    callbacks: {
      footer: function footer() {
        return ' ';
      }
    },
    cornerRadius: parseInt(theme.borderRadius.slice(0, -1)),
    displayColors: false,
    intersect: false,
    mode: 'index',
    backgroundColor: theme.highContrast,
    bodyFontColor: theme.lowContrast,
    bodyFontFamily: theme.fontFamilySansSerif,
    bodyFontSize: 14,
    bodyFontStyle: 'normal',
    bodyMarginBottom: 6,
    bodySpacing: 0,
    footerFontColor: theme.lowContrast,
    footerFontFamily: theme.fontFamilySansSerif,
    footerFontSize: 6,
    footerFontStyle: 'normal',
    footerMarginTop: 0,
    footerSpacing: 0,
    titleFontColor: theme.lowContrast,
    titleFontFamily: theme.fontFamilySansSerif,
    titleFontSize: 16,
    titleFontStyle: 'normal',
    titleMarginBottom: 6,
    titleSpacing: 0,
    xPadding: 6,
    yPadding: 6
  };
};